import { render, staticRenderFns } from "./AssuntoAgroVisitaList.vue?vue&type=template&id=bf2a2172&scoped=true"
import script from "./AssuntoAgroVisitaList.vue?vue&type=script&lang=js"
export * from "./AssuntoAgroVisitaList.vue?vue&type=script&lang=js"
import style0 from "./AssuntoAgroVisitaList.vue?vue&type=style&index=0&id=bf2a2172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2a2172",
  null
  
)

export default component.exports